import React, { createContext, useContext, useState, useEffect } from 'react';
import { valorDolar } from "../api/parametros.api.ts";

// Crear el contexto
const DolarContext = createContext();

// Hook personalizado para usar el contexto
export const useDolar = () => {
    const context = useContext(DolarContext);
    if (!context) {
        throw new Error('useDolar debe ser usado dentro de un DolarProvider');
    }
    return context;
};

// Proveedor del contexto
export const DolarProvider = ({ children }) => {
    const [dolar, setDolar] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchDolarValue = async () => {
        try {
            setLoading(true);
            const response = await valorDolar();
            const valorDolarConMargen = response.data.valor;
            setDolar(valorDolarConMargen);
            setError(null);
        } catch (error) {
            console.error("Error al obtener el valor del dólar:", error);
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDolarValue();
        
        // Actualizar cada 30 minutos
        const interval = setInterval(() => {
            fetchDolarValue();
        }, 1800000); // 30 minutos en milisegundos

        return () => clearInterval(interval);
    }, []);

    const value = {
        dolar,
        loading,
        error,
        refreshDolar: fetchDolarValue
    };

    return (
        <DolarContext.Provider value={value}>
            {children}
        </DolarContext.Provider>
    );
};

export default DolarContext;